import React, { useState } from 'react'
import { ChatFeed } from 'react-chat-ui'
import ChatSelector from './NewMessageContainer/ChatSelector'
import UnansweredMessageInfo from './UnansweredMessageInfo'
import ReggoraChatBubble from '../../common/widgets/ReggoraBubble'
import CommentTemplateDropdown from './CommentTemplateDropdown'
import { useFlags } from 'launchdarkly-react-client-sdk'

const MessagesTab = (props) => {
  const {
    messagesBubbles,
    messages,
    conversationParticipation,
    conversation,
    markReadMessages,
    is_amc_lender,
    isAppraiserMessages,
    subOrderId,
    conversationType,
    newMessageTitle,
    orderData,
  } = props
  const isTeamConversation = conversationType === 'team_conversation'
  const flags = useFlags() || {}

  const [textToInsert, setTextToInsert] = useState('')
  const [selectedTemplate, setSelectedTemplate] = useState(null)

  const audienceFilter = conversationType === 'unified_conversation' || is_amc_lender
    ? null
    : 'internal'

  const onNewMessageFocus = () => markReadMessages(conversation.id, conversationType)

  const handleTextToInsert = (textToInsert, type) => {
    setTextToInsert(textToInsert)
    // Only clear selectedTemplate if:
    // 1. User is typing manually AND
    // 2. Either there's no selectedTemplate OR the selectedTemplate is pre-approved OR the text is empty
    // This allows editing non-pre-approved templates without losing focus
    if (type === 'manual') {
      if (!selectedTemplate || selectedTemplate?.is_pre_approved || !textToInsert.trim()) {
        setSelectedTemplate(null)
      }
      // Otherwise, keep selectedTemplate for non-pre-approved templates so user can edit
    }
  }

  return (
    <div className="d-flex flex-column align-content-between chat-controls" name={conversationType}>
      <div className="chat-avatars">{messagesBubbles}</div>
      <ChatFeed
        messages={messages}
        chatBubble={ReggoraChatBubble}
        showSenderName={false}
      />
      {conversationParticipation && (
        ((is_amc_lender && isAppraiserMessages) || (isTeamConversation && flags?.useUpdatedMessageTemplatesUx)) ? (
          <>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center', width: '100%' }}>
              <ChatSelector
                conversation_id={conversation.id}
                conversationType={conversationType}
                is_revision={false}
                modal={false}
                subOrderId={subOrderId}
                onFocus={onNewMessageFocus}
                newMessageTitle={newMessageTitle}
                orderData={orderData}
                is_amc_lender={is_amc_lender}
                textToInsert={textToInsert}
                setTextToInsert={handleTextToInsert}
                selectedTemplate={selectedTemplate}
                setSelectedTemplate={setSelectedTemplate}
                resetTextToInsert={() => setTextToInsert('')}
                allowMessageParticipation={true}
                shouldGetMessages={true}
                primaryConversationType={conversationType}
                primaryConversation={conversation}
                onHide={props.onHide}
                refreshOrder={props.refreshOrder}
                isUnifiedConversation={conversationType === 'unified_conversation'}
                isTemplateSuggestionEnabled={false}
                audienceFilter={audienceFilter}
              />
            </div>
            {!flags?.useUpdatedMessageTemplatesUx && isAppraiserMessages && <CommentTemplateDropdown
              name={'appraiser-messages-templates-list'}
              onHide={props.onHide}
              refreshOrder={props.refreshOrder}
              setTextToInsert={handleTextToInsert}
              setSelectedTemplate={setSelectedTemplate}
            />}
          </>
        ) : <ChatSelector
          conversation_id={conversation.id}
          conversationType={conversationType}
          is_revision={false}
          modal={false}
          subOrderId={subOrderId}
          onFocus={onNewMessageFocus}
          newMessageTitle={newMessageTitle}
          textToInsert={textToInsert}
          setTextToInsert={handleTextToInsert}
          orderData={orderData}
          is_amc_lender={is_amc_lender}
          selectedTemplate={selectedTemplate}
          setSelectedTemplate={setSelectedTemplate}
          resetTextToInsert={() => setTextToInsert('')}
          allowMessageParticipation={true}
          shouldGetMessages={true}
          primaryConversationType={conversationType}
          primaryConversation={conversation}
          onHide={props.onHide}
          refreshOrder={props.refreshOrder}
          isUnifiedConversation={conversationType === 'unified_conversation'}
          audienceFilter={audienceFilter}
        />
      )}
      {isAppraiserMessages && (
        <UnansweredMessageInfo
          primaryConversation={conversation || {}}
          is_amc_lender={is_amc_lender}
          shouldGetMessages={true}
        />
      )}
    </div>
  )
}

export default MessagesTab
